import { resolveMediaUrl } from './mediaUrl';

const API_BASE =
  (typeof process !== 'undefined' && process.env.REACT_APP_API_URL) || '/api';

function getApiOrigin() {
  if (typeof window === 'undefined') return '';
  if (window.location.hostname !== 'localhost') return '';

  const apiUrl = process.env.REACT_APP_API_URL || '/api';
  if (apiUrl.startsWith('http')) {
    return apiUrl.replace(/\/api\/?$/, '');
  }
  return 'http://localhost:8002';
}

/**
 * Public URL to open/download a nav or footer document.
 * In dev, uses backend origin so Megtekintés opens the PDF (not the SPA 404).
 */
export function getDocumentUrl(doc) {
  if (!doc) return '#';
  if (doc.externalUrl) return doc.externalUrl;
  if (doc._id && doc.filePath) {
    const devOrigin = getApiOrigin();
    if (devOrigin) {
      return `${devOrigin}/api/documents/${doc._id}/download`;
    }
    const base = API_BASE.replace(/\/$/, '');
    return `${base}/documents/${doc._id}/download`;
  }
  if (doc.filePath) {
    return resolveMediaUrl(`/uploads/${doc.filePath}`);
  }
  return '#';
}
